/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMedicalHistoryTypename = "PhrMedicalHistory" as const;

/**
 *
 * @export
 * @interface PhrMedicalHistory
 */
export interface PhrMedicalHistory {
  /**
   *
   * @type {string}
   * @memberof PhrMedicalHistory
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalHistory
   */
  hasDisease?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicalHistory
   */
  readonly __typename?: string;
}

export function PhrMedicalHistoryFromJSON(json: any): PhrMedicalHistory {
  return PhrMedicalHistoryFromJSONTyped(json, false);
}

export function PhrMedicalHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMedicalHistory {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicalHistoryTypename,

    description: !exists(json, "description") ? undefined : json["description"],
    hasDisease: !exists(json, "has_disease") ? undefined : json["has_disease"],
  };
}

export function PhrMedicalHistoryToJSON(object?: PhrMedicalHistory | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    description: value.description,
    has_disease: value.hasDisease,
  };
}
